import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';

const ConfirmationDialog = ({ setDialogOpen, onArchive, onDismiss, isDialogOpen, member }) => (
  <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
    <DialogTitle>
      <Typography sx={{ fontSize: '18px', fontWeight: '600', color: 'black' }}>
        Are you sure you want to archive this account?
      </Typography>
      <IconButton
        aria-label="close"
        onClick={() => setDialogOpen(false)}
        sx={{ position: 'absolute', right: 8, top: 8 }}
        size="large"
      >
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <DialogContentText
        sx={{ color: 'black', fontSize: '16px', fontWeight: '400' }}
        id="confirmation-dialog-description"
      >
        You are about to archive the account of{' '}
        <span style={{ fontSize: '16px', fontWeight: '600', color: 'black' }}>
          {member?.displayName} ({member?.email}).
        </span>{' '}
      </DialogContentText>
      <DialogActions>
        <Button sx={{ color: 'black' }} onClick={onDismiss}>
          Cancel
        </Button>
        <Button sx={{ color: 'red' }} onClick={onArchive}>
          Archive
        </Button>
      </DialogActions>
    </DialogContent>
  </Dialog>
);

export default ConfirmationDialog;
